// src/components/ParentsNoteModal.jsx
import React from "react";

export default function ParentsNoteModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[1000] bg-black/40 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl rounded-2xl bg-white shadow-xl p-6">
        <div className="flex items-start gap-4">
          <div className="shrink-0 text-2xl">👨‍👩‍👧‍👦</div>
          <div>
            <h2 className="text-xl font-semibold">A quick note for grown-ups</h2>
            <p className="text-gray-700 mt-2">
              <strong>Treble Town</strong> makes learning piano playful and fast. Guided by
              friendly characters like <strong>Pan the Panda</strong>, many children learn
              <strong> 10 songs</strong> over just a few short sessions.
            </p>
            <ul className="list-disc pl-5 mt-3 space-y-2 text-gray-700">
              <li>
                Please help your child allow <strong>microphone access</strong>. Treble Town
                listens to the piano/keyboard and gives <strong>live feedback</strong> on notes.
              </li>
              <li>
                Any basic keyboard or acoustic piano works. Place your device near the instrument
                for clear sound.
              </li>
              <li>
                Progress saves on this device. You can log in with a parent email later to sync
                progress and unlock premium chapters.
              </li>
            </ul>
            <p className="text-gray-700 mt-3">
              Audio is analyzed on-device to check pitch and timing. We keep Treble Town a safe,
              child-friendly space. 💛
            </p>
          </div>
        </div>
        <div className="flex justify-end mt-5">
          <button onClick={onClose} className="px-4 py-2 rounded-lg bg-amber-400 hover:bg-amber-300 font-medium">
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
}
